var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertMore = function SvgAlertMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#AlertMore_svg__a)",
    stroke: "current",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 9.1c0-.557.23-1.091.64-1.485.41-.394.966-.615 1.546-.615h.625c.58 0 1.136.221 1.546.615.41.394.64.928.64 1.485.023.454-.086.905-.312 1.284a1.921 1.921 0 0 1-.937.816c-.383.201-.712.583-.938 1.088A3.893 3.893 0 0 0 11.998 14M12 17h.01"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "AlertMore_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgAlertMore;